import lrTenantName from './_src/lrTenantName.vue'
lrTenantName.install = function(Vue) {
  Vue.component(lrTenantName.name, lrTenantName)
}

export default lrTenantName